import DataGrid, { DataGridConfig } from 'components/DataGrid';
import React, { useState } from 'react';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';

// Define the dataset type for MultiViewChart
export type ChartDataSet = {
  dataset: number[];
  label: string;
  color: string;
  getDrillDownUrl: (label: string) => string;
};

// Props type for the MultiViewChart component
interface DashboardDataGridChartProps {
  data: unknown[];
  header: string;
  subHeader: string;
  dataGridConfig: Pick<DataGridConfig, 'rowIdKey' | 'columns'>;
}

const DashboardDataGridChart: React.FC<DashboardDataGridChartProps> = ({
  data,
  header,
  subHeader,
  dataGridConfig,
}) => {
  // Inline component for rendering the DataGrid with pagination
  const TableView: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(0);
    const pageSize = 7; // Fixed page size

    const paginatedData = data.slice(
      currentPage * pageSize,
      (currentPage + 1) * pageSize,
    );

    const mergedConfig: DataGridConfig = {
      ...dataGridConfig, // Merge rowIdKey and columns from props
      paginationConfig: {
        total_count: data.length,
        pageNumber: currentPage,
        pageSize: pageSize,
        rowsPerPageOptions: [], // Disable page size dropdown
        onPageChange: (newPage) => setCurrentPage(newPage),
      },
    };

    return <DataGrid config={mergedConfig} data={paginatedData} />;
  };

  // Function to render content based on the selected view
  const renderContent = () => {
    return <TableView />;
  };

  // Header for the chart card
  const chartHeader = (
    <CardHeader>
      <Row>
        <Col className="d-flex flex-row align-items-baseline">
          <h2 className="d-inline mb-0">{header}</h2>
          <h5 className="card-category px-1">{subHeader}</h5>
        </Col>
      </Row>
    </CardHeader>
  );

  return (
    <Card className="card-chart border border-light">
      {chartHeader}
      <CardBody className="pb-0">
        {/* Content area for the chart or table */}
        <div
          className="chart-area overflow-auto"
          style={{ overflowX: 'hidden' }}
        >
          {renderContent()}
        </div>
      </CardBody>
    </Card>
  );
};

export default DashboardDataGridChart;
